<script setup lang="ts">
import { computed } from 'vue'
import { Duration } from 'luxon'
import { T } from '@tolgee/vue'
import { twMerge } from 'tailwind-merge'

const props = defineProps<{
	countdown: number
	boxOuterClass?: string
}>()

const countdownObject = computed(() => {
  return props.countdown > (72 * 3600) ?
    Duration.fromObject({ seconds: props.countdown }).shiftTo('days', 'hours', 'minutes', 'seconds').toObject() :
    Duration.fromObject({ seconds: props.countdown }).shiftTo('hours', 'minutes', 'seconds').toObject()
})
</script>
<template>
  <div
    class="grid grid-cols-3 gap-x-4"
  >
    <div
      v-if="countdown > (72 * 3600)"
      :class="twMerge('p-0.5 bg-gray-gradient flex flex-col items-center rounded-xl', boxOuterClass)"
    >
      <div class="bg-dark-bottom-layer py-3 w-full h-full rounded-[11px] flex flex-col items-center">
        <span class="text-white font-medium text-[32px] leading-8">{{ countdownObject.days?.toFixed() }}</span>
        <span class="text-sm font-semibold text-white/60">
          <T
            key-name="rewards.extra_tab.days"
            default-value="Days"
          />
        </span>
      </div>
    </div>
    <div :class="twMerge('p-0.5 bg-gray-gradient flex flex-col items-center rounded-xl', boxOuterClass)">
      <div class="bg-dark-bottom-layer py-3 w-full h-full rounded-[11px] flex flex-col items-center">
        <span class="text-white font-medium text-[32px] leading-8">{{ countdownObject.hours?.toFixed() }}</span>
        <span class="text-sm font-semibold text-white/60">
          <T
            key-name="rewards.extra_tab.hours"
            default-value="Hours"
          />
        </span>
      </div>
    </div>
    <div :class="twMerge('p-0.5 bg-gray-gradient flex flex-col items-center rounded-xl', boxOuterClass)">
      <div class="bg-dark-bottom-layer py-3 w-full h-full rounded-[11px] flex flex-col items-center">
        <span class="text-white font-medium text-[32px] leading-8">{{ countdownObject.minutes?.toFixed() }}</span>
        <span class="text-sm font-semibold text-white/60">
          <T
            key-name="rewards.extra_tab.minutes"
            default-value="Minutes"
          />
        </span>
      </div>
    </div>
    <div
      v-if="countdown <= (72 * 3600)"
      :class="twMerge('p-0.5 bg-gray-gradient flex flex-col items-center rounded-xl', boxOuterClass)"
    >
      <div class="bg-dark-bottom-layer py-3 w-full h-full rounded-[11px] flex flex-col items-center">
        <span class="text-white font-medium text-[32px] leading-8">{{ countdownObject.seconds?.toFixed() }}</span>
        <span class="text-sm font-semibold text-white/60"> <T
          key-name="rewards.extra_tab.seconds"
          default-value="Seconds"
        />
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.bg-gray-gradient {
	background: rgba(255, 255, 255, 0.38)
}

.bg-gold-gradient {
	background-image: linear-gradient(
			to right,
			#fff246 0%,
			#e5b80b 37%,
			#fff571 69%,
			#e5b80b 100%
	);
}
</style>